import { useCallback } from 'react';
import useStore from '@components/MainStage/store';

/**
 * Returns the canvas to its default, non-selected state once a drawer save
 * has been applied. Shortcut saves keep the drawer open on the element still
 * being edited, so they are skipped.
 */
const useResetSelectionAfterSave = () => {
  const unselectActiveNode = useStore((s) => s.unselectActiveNode);
  const unselectActiveEdge = useStore((s) => s.unselectActiveEdge);

  return useCallback(
    (fromShortcut?: boolean) => {
      if (fromShortcut) return;

      unselectActiveNode();
      unselectActiveEdge();
    },
    [unselectActiveNode, unselectActiveEdge],
  );
};

export default useResetSelectionAfterSave;
